import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Layout from "./pages/Layout";
import FormPage from "./pages/Form";
import ShowPage from "./pages/SubPage";
import Referral from "./pages/Referral";
import Home from "./pages/Home";
import HomeEmployee from "./pages/HomeEmployee";
import MileageForm from "./pages/MileageForm";
import { Helmet } from 'react-helmet-async';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import DeedPage from "./pages/CountyDeed";
import deltaLogo from './pictures/logo.png'
import Utility from "./pages/Utility";
import Municipality from "./pages/Municipality";
import Title from "./pages/Title";
import TrainingCalendar from "./pages/TrainingCalendar";
import Calculator from "./pages/EstimatedCostCalculator";
import { Authenticator, Heading, View, Button, useTheme, useAuthenticator } from '@aws-amplify/ui-react';
import EstimatedCostCalculator from "./pages/EstimatedCostCalculator";
Amplify.configure(awsconfig);

// -------------------- Custom Components --------------------
const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Heading level={2} color="#012f3f">
          <span className="app-color-red">RE</span><span className="app-color-blue">/</span><span className="app-color-red">MAX</span> Delta Group Inc. Agent Portal
        </Heading>
      </View>
    );
  },
  Footer() {
    return null; // optional global footer for the Authenticator
  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
          color="#012f3f"
          textAlign="center"
          marginTop={15}
        >
          Sign in to your account
        </Heading>
      );
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();

      return (
        <View textAlign="center" padding="10px 0">
          <Button
            fontWeight="normal"
            onClick={toForgotPassword}
            size="small"
            variation="link"
          >
            Forgot Password?
          </Button>
        </View>
      );
    },
  },
};

// -------------------- Form Fields --------------------
const formFields = {
  signIn: {
    username: { placeholder: 'Enter your email' },
  },
  signUp: {
    username: { placeholder: 'Enter your email' },
    password: { label: 'Password', placeholder: 'Enter your password', order: 2 },
    confirm_password: { label: 'Confirm Password', order: 1 },
  },
};

// -------------------- Main App --------------------
const App = () => {
  return (
    <div>
      <img  
        src={deltaLogo} 
        alt="Logo" 
        className="app-logo"
        style={{ cursor: 'pointer' }}/>
    <Authenticator hideSignUp components={components} formFields={formFields} className="auth-wrapper">
      {({ signOut, user }) => (
        <>
          {!user ? null : (
            <BrowserRouter>
              <Helmet>
                <title>Delta Group Agent Portal</title>
                <meta name="description" content="Welcome to the Agent Portal for Delta Group Inc."/>
                <link rel="canonical" href="/" />
              </Helmet>
              <Routes>
                  <Route path="/" element={<Layout signOut={signOut}/>}>
                  <Route index element={<Home />} />
                  <Route path="/training-calendar" element={<TrainingCalendar />} />
                  <Route path="lander" element={<Home />} />
                  <Route path="ehome" element={<HomeEmployee />} />
                  <Route path="/mileage" element={<MileageForm />} />
                  <Route path="form" element={<FormPage />} />
                  <Route path="showing-page" element={<ShowPage />} />
                  <Route path="utility" element={<Utility />} />
                  <Route path="deed" element={<DeedPage />} />
                  <Route path="referral" element={<Referral />} />
                  <Route path="calculator" element={<EstimatedCostCalculator />} />
                   <Route path="title" element={<Title />} />
                  <Route path="/municipality/:countyKey" element={<Municipality />} />
                </Route>
              </Routes>
            </BrowserRouter>
          )}
        </>
      )}
    </Authenticator>
    </div>
  );
};

export default App;
